module.exports = __webpack_public_path__ + "static/media/empty_mailbox3.bb21edff.jpg";